import React from "react";
import styles from "./IconCountList.scss";

import { Item } from "./Item";

export const IconCountList = ({ children }) => {
    const items = React.Children.toArray(children)?.filter((child) => child.type === Item);
    return items?.length ? (
        <table className={styles.base}>
            <tbody>
                <tr>
                    {items.map(({ props }, index) => (
                        <td key={index}>
                            <div className={styles.label}>{props.label}</div>
                            {props.children != null ? <div className={styles.value}>{props.children}</div> : null}
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    ) : null;
};
